import React, { FC } from 'react';

import { Flex } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';

import { useTranslation } from '../i18n';

interface EntityPickerModalLoadMoreButtonProps {
  onLoadMore: () => void;
}

const EntityPickerModalLoadMoreButton: FC<
  EntityPickerModalLoadMoreButtonProps
> = ({ onLoadMore }) => {
  const { t } = useTranslation();
  return (
    <Flex alignItems="center" height="68px" paddingLeft="50px">
      <LinkButton onClick={onLoadMore}>{t('LOAD_MORE')}</LinkButton>
    </Flex>
  );
};

export default EntityPickerModalLoadMoreButton;
